<product-social-share [model]="product()" />
@if (product().data?.sku) {
<span class="block">Code: {{product().data?.sku}}</span>
}